import { SafePromise } from '@benzinga/safe-await';
import { Subscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';
import { Geo } from './entities';
import { GeoRequest, GeoRestfulEvent } from './request';

export type GeoManagerEvent = GeoRestfulEvent;

export class GeoManager extends Subscribable<GeoManagerEvent> {
  private request: GeoRequest;

  constructor(session: Session) {
    super();
    this.request = new GeoRequest(session);
  }

  public static getName = () => 'benzinga-geo';

  public getGeoLocation = async (): SafePromise<Geo> => {
    return await this.request.getGeoLocation();
  };

  public getZipCode = async (): SafePromise<string | undefined> => {
    const geoLocationResponse = await this.getGeoLocation();
    const city = geoLocationResponse.ok?.city;
    const region = geoLocationResponse.ok?.region;

    if (city && region) {
      return await this.request.getZipCode(city, region);
    } else {
      return { ok: undefined };
    }
  };
}
